import guidesContent from "./guidesContent";

const siteConfig = {
  serverName: "Mu Beginning",
  version: "Season 6 Episode 3",
  experience: "20x",
  dropRate: "5%",
  location: "Europe (Israel)",
  // Live players online / events / stats come from /web APIs.
  playersOnlineLabel: "Players Online",
  playersOnlineValue: "—",
  playersCapacity: "—",

  social: {
    discordInvite: "https://discord.gg/evW2sCXkgg",
    discordWidget:
      "https://discord.com/widget?id=1407000815784431677&theme=dark",
    facebook: "https://www.facebook.com/mubeginning",
    youtube: "https://www.youtube.com",
  },

  featuredItem: {
    title: "Season 6 Exclusive Sets",
    subtitle: "Dungeon Nightemare",
    image: null,
    link: "/guides?cat=systems&topic=dungeons",
  },

  gallery: [
    { label: "User: DarkKnight", image: null },
    { label: "User: MagicLord", image: null },
    { label: "User: QueenElf", image: null },
    { label: "User: BladeMaster", image: null },
  ],

  // Fallback names only — live times from /web/eventTimes
  upcomingEvents: [
    { name: "Blood Castle", accent: "#c0392b" },
    { name: "Devil Square", accent: "#3498db" },
    { name: "Chaos Castle", accent: "#9b59b6" },
    { name: "Golden Invasion", accent: "#f1c40f" },
    { name: "White Wizard", accent: "#2ecc71" },
  ],

  /*
    Home News & Announcements titles = article headings on /news.
    Edit / add entries here to publish news on the site.
  */
  news: [
    {
      id: "season-open",
      title: "Season 6 Episode 3 — Server Open",
      date: "2024-05-30",
      tag: "NEW",
      body: [
        "Welcome to Mu Beginning Season 6 Episode 3.",
        "The server is open for all warriors. Create your character, join Discord, and start your journey.",
        "Stay tuned for upcoming events, balance updates, and exclusive Season 6 rewards.",
      ],
    },
    {
      id: "events-schedule",
      title: "Events Schedule & Rewards",
      date: "2024-05-28",
      body: [
        "Blood Castle, Devil Square, Chaos Castle and more run on a regular schedule.",
        "Check the Events page for times and reward details. Participate daily to earn Zen, jewels and rare items.",
      ],
    },
    {
      id: "commands-guide",
      title: "In-Game Commands Guide",
      date: "2024-05-26",
      body: [
        "Learn the essential in-game commands for resets, moves, warehouse and party tools.",
        "Open Guides for systems and events, or visit the Commands page from the menu.",
      ],
    },
    {
      id: "client-download",
      title: "Client Download & Updates",
      date: "2024-05-24",
      body: [
        "Download the latest Mu Beginning client from the Downloads page.",
        "Always use the official launcher/client package to avoid version mismatch and connection issues.",
      ],
    },
  ],

  /*
    Guides page (/guides): full content in guidesContent.js (synced to MuServer Data).
  */
  guides: guidesContent,
};

export default siteConfig;
